<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks'

    export default {
        components: {
            AppTabLinks
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Сервис',
                        url: `/settings/entities/${this.$route.params.id}/common`
                    },
                    {
                        title: 'Редактировать',
                        url: `/settings/entities/${this.$route.params.id}/common/edit`
                    },
                ]
            }
        }
    }
</script>
